import { Copy, Maximize2, Bot } from 'lucide-react';
import React, { useEffect, useState, useRef } from "react";

import { useParams, useHistory } from "react-router-dom";
import DOMPurify from "dompurify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getCopilotMultimodalStream } from "../../../../../services/staffingService";
import gfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
// import conversationHistory from "./conversationHistory.json";
// import HandsOnTable from "./handsOnTable";

// import ShareIcon from "@mui/icons-material/Share";




import { Editor } from "@tinymce/tinymce-react";





import Send from "../../../../_asset/img/send-2.svg";
// import Rectangle from "../../../../_asset/img/Rectangle.svg";
import { ReactComponent as Magicpen } from "../../../../_asset/img/magicpen.svg";
import Paperclip from "../../../../_asset/img/paperclip-2.png";

const schema = yup
  .object({
    prompt: yup
      .string()
      .required("Prompt is required")
      .max(3200, "Max length exceeded"),
  })
  .required();

const Copilot = () => {
  const [loading, setLoading] = useState(false);

  const [conversation, setConversation] = useState([]);

  const [prompt, setPrompt] = useState("");
  const [completion, setCompletion] = useState("");
  const [completionLoading, setCompletionLoading] = useState(false);
  const [completionError, setCompletionError] = useState(true);

  const [showFullscreen, setShowfullscreen] = useState(false);

  const [completionSettingsExists, setCompletionSettingsExists] = useState(false);
  const [fileId, setFileId] = useState("");
  const [sourceBlob, setSourceBlob] = useState("");
  const [asset, setAsset] = useState("");
  const [assetSaved, setAssetSaved] = useState(false);
  const [err, setErr] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lastwords, setLastwords] = useState("");
  const [df, setDf] = useState([]);

  const chatContainerRef = useRef(null);
  const chatEndRef = useRef(null);
  const history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const editorRef = useRef(null);

  const hotRef = React.useRef(null);

  useEffect(() => {
    /*
    const fetchModelDetails = async () => {
      try {
        setLoading(true);
        let resp2 = conversationHistory;
        let convHistory = [];
        resp2.data.conv.forEach((item) => {
          item.choices.forEach((choice) => {
            convHistory.push(choice.message);
          });
        });
        setConversation([...convHistory]);
        setAsset(resp2.data.asset.content);
        setPrompt("resp_card.data.prompt");
        setLoading(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          history.push("/404");
        }
      }
    };
    */
    //fetchModelDetails();
  }, [history]);

  useEffect(() => {
    const codeElements = document.querySelectorAll(
      '.chat-container .message-content p > pre > code[class^="language-"]'
    );
    codeElements.forEach((el) => {
      const langMatch = el.className.match(/language-(\w+)/);
      if (langMatch && langMatch[1]) {
        el.parentElement.setAttribute("data-lang", langMatch[1]);
      }
    });
  }, [conversation]);

  const onSubmit = async (data) => {
    console.log("submitted +++++++ prompt +++++ ", data);
    setErr("");
    setCompletionLoading(true);
    try {
      setConversation((prevConversation) => [
        ...prevConversation,
        { role: "user", content: data.prompt },
      ]);
      const resp = await getCopilotMultimodalStream(data.prompt);

     if (!resp.ok || !resp.body) {
        setCompletionError(true);
        setConversation((prevConversation) => [
            ...prevConversation,
            { role: "assistant", content: resp.data.errmessage, err: true },
        ]);
        setCompletionLoading(false);
        reset();
        throw resp.statusText;
       }

      const reader = resp.body.getReader();
      const decoder = new TextDecoder();
      const loopRunner = true;
      let result = "";

      while (loopRunner) {
        const { value, done } = await reader.read();
        if (done) {
          break;
        }
        const decodedChunk = decoder.decode(value, { stream: true });
        let compl = decodedChunk;
        result += compl;

        setLastwords(result);
        reset();
      }
      setLastwords("");
      setCompletion(result);
      setPrompt(data.prompt);
      setCompletionLoading(false);
      setConversation((prevConversation) => [
        ...prevConversation,
        { role: "assistant", content: result },
      ]);
    } catch (ex) {
      if (ex.response && ex.response.status === 404) {
        setErr(ex.response.data);
      }
      setCompletionLoading(false);
      //setHighlightedRanges([])
    }
  };

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView();
    }
  }, [conversation, lastwords]);

  const toggleModal = () => {
    setIsModalOpen((prevState) => !prevState);
  };

  const handleFullscreen = (content) => {
    const serializedConversation = encodeURIComponent(JSON.stringify(content));
    window.open(
      `/copilot/junior-analyst/response/full-screen?conversation=${serializedConversation}`,
      "_blank"
    );
  };

  return (
    <div className="flex flex-col h-full font-inter bg-white">
      <div className={`flex-1 overflow-y-auto p-4 ${conversation.length > 0 ? 'w-full' : 'w-full max-w-3xl mx-auto'}`}>
        
        {!conversation.length && (
          <div className="flex flex-col items-center justify-center h-full text-center">
            <div className="mb-4 p-4 bg-gray-100 rounded-full">
              <Magicpen />
            </div>
            <p className="text-gray-600 text-lg">
              Ask me anything about the service level agreement with this officer.
            </p>
          </div>
        )}

        {conversation.length > 0 && (
          <div className="space-y-4 chat-container max-w-4xl mx-auto">
            {conversation.map((item, index) => (
              <React.Fragment key={index}>
                {item.role === "user" && (
                  <div className="flex justify-end">
                    <div className="bg-[#404880] text-white p-3 rounded-lg max-w-xs md:max-w-md lg:max-w-lg">
                      <p className="text-sm">{item.content}</p>
                    </div>
                  </div>
                )}
                {item.role === "assistant" && !item.err && (
                  <div className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <Bot className="text-[#404880] text-2xl" />
                    </div>
                    <div className="flex-1 bg-gray-50 p-4 rounded-lg relative group">
                      <div className="prose prose-sm max-w-none message-content">
                        <ReactMarkdown
                          children={item.content}
                          remarkPlugins={[gfm]}
                        />
                      </div>
                      <div className="absolute top-2 right-2 flex space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          type="button"
                          onClick={() => handleFullscreen(item.content)}
                          className="p-1 bg-white rounded shadow hover:bg-gray-50"
                        >
                          <Maximize2 className="text-[#404880] text-sm" />
                        </button>
                        <button
                          type="button"
                          className="p-1 bg-white rounded shadow hover:bg-gray-50"
                        >
                          <Copy className="text-[#404880] text-sm" />
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {item.role === "assistant" && item.err && (
                  <div className="text-center">
                    <p className="text-red-500 text-sm bg-red-50 p-3 rounded-lg">{item.content}</p>
                  </div>
                )}
              </React.Fragment>
            ))}
            {lastwords && (
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0">
                  <Bot className="text-[#404880] text-2xl" />
                </div>
                <div className="flex-1 bg-gray-50 p-4 rounded-lg">
                  <div className="prose prose-sm max-w-none">
                    <ReactMarkdown
                      children={lastwords}
                      remarkPlugins={[gfm]}
                    />
                  </div>
                </div>
              </div>
            )}
            <div ref={chatEndRef}></div>
          </div>
        )}
      </div>
      
      {!completionLoading && (
        <div className="border-t border-gray-200 p-4 mt-auto bg-white">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex items-end space-x-3">
              <div className="flex-1">
                <textarea
                  {...register("prompt")}
                  rows={2}
                  placeholder="Ask AI about this officer..."
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
                {errors.prompt && (
                  <span className="text-red-500 text-xs mt-1 block">
                    {errors.prompt.message}
                  </span>
                )}
              </div>
              <button 
                type="submit"
                className="px-6 py-3 bg-[#404880] text-white text-sm rounded-lg hover:bg-[#363e70] transition-colors flex-shrink-0"
              >
                Send
              </button>
            </div>
          </form>
        </div>
      )}

      {completionLoading && (
        <div className="border-t border-gray-200 p-4 mt-auto bg-white">
          <div className="flex items-center space-x-3">
            <div className="flex-1">
              <div className="w-full px-4 py-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-500 text-sm">
                AI is thinking...
              </div>
            </div>
            <div className="flex-shrink-0 px-6 py-3">
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Copilot;
